<div class="cursor-pointer w-full" (click)="selectMethod($event)">
    <div class="w-full">
        <img class="other-payment-options" src="assets/icons/Icons/other-payment-options/OTT Voucher-full black smaller.png" alt="ott voucher">
    </div>
    <div class="grid grid-cols-5 gap-1">
        <p class="col-span-4 subtext mt-2">Pay using an OTT voucher</p>
        <div class="col-span-1">
            <mat-icon class="cursor-pointer float-right" (click)="toggleListView()">info</mat-icon>
        </div>
    </div>
</div>
